import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Menu, MenuItem } from "react-pro-sidebar";
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import "./topNavigation.css";
import { ROUTES, MAIN_LOGO_WHITE, PROFILE_IMAGE } from "../../../constant";
import { loadData } from '../../../utils/localStorage';
import LogoutModal from "../../auth/logout/logout";
import IconButton from "../iconbutton/iconButton";
import { getTabsInfo } from "../../../utils/tabsUtils";


const TopNavigation = (props) => {

    const [sidebarHide, setSidebarHide] = useState(false);
    const [logoutModal, setLogoutModal] = useState(false);

    const userData = JSON.parse(loadData("user"));
    const permissionPolicy = userData?.role_permission?.permission_policy;
    const roleType = userData?.role_permission?.role_type;
    const tabsInfo = getTabsInfo(roleType, permissionPolicy);

    const navigate = useNavigate();

    const menuItemStyles = {
        root: {
            fontSize: "14px",
            fontWeight: 500,
            color: "rgba(255,255,255,0.88)",
        },
        icon: {
            color: "rgba(255,255,255,0.60)",
            fontSize: "15px",
        },
        SubMenuExpandIcon: {
            color: "rgba(255,255,255,0.35)",
        },
        button: {
            borderRadius: "8px",
            margin: "1px 8px",
            width: "calc(100% - 16px)",
            transition: "background 0.15s",
            "&:hover": {
                backgroundColor: "rgba(255,255,255,0.07)",
                color: "#ffffff",
            },
        },
        label: ({ open }) => ({
            fontWeight: open ? 700 : 500,
            color: "rgba(255,255,255,0.88)",
        }),
    };

    const mobileActiveStyle = {
        backgroundColor: "rgba(251,182,21,0.14)",
        borderLeft: "3px solid #fbb615",
        color: "#ffffff",
    };

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (!props.tabs || !props.activeTab || !props.onTabChange) return;
            const currentIndex = props.tabs.findIndex(t => t.id === props.activeTab);
            if (e.altKey && e.key === 'ArrowLeft' && currentIndex > 0) {
                props.onTabChange(props.tabs[currentIndex - 1].id);
            }
            if (e.altKey && e.key === 'ArrowRight' && currentIndex < props.tabs.length - 1) {
                props.onTabChange(props.tabs[currentIndex + 1].id);
            }
        };
        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
    }, [props.tabs, props.activeTab, props.onTabChange]);

    const handleSidebarShow = () => setSidebarHide(true);
    const handleSidebarClose = () => setSidebarHide(false);
    const handleLogout = () => setLogoutModal(true);
    const handleCloseLogoutModal = () => setLogoutModal(false);

    const profilePopover = (
        <Popover id="popover-basic" style={{ width: "300px", padding: 0, overflow: "hidden", borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 8px 30px rgba(41,54,89,0.15)" }}>
            <Popover.Body style={{ padding: 0 }}>
                {/* Hero strip */}
                <div className='prof-popup-hero'>
                    <div className='prof-popup-avatar-wrap'>
                        <img
                            src={userData?.profile_image ? userData?.profile_image : PROFILE_IMAGE}
                            alt="user profile"
                            className='prof-popup-avatar'
                        />
                    </div>
                </div>

                {/* Info block */}
                <div className='prof-popup-body'>
                    <p className='prof-popup-name'>{userData?.first_name} {userData?.last_name}</p>
                    {userData?.role_permission?.role_name && (
                        <span className='prof-popup-role-badge'>{userData?.role_permission?.role_name}</span>
                    )}
                    <p className='prof-popup-email'>
                        <i className="bi bi-envelope"></i>
                        {userData?.email}
                    </p>
                </div>

                <hr className='prof-popup-divider' />

                {/* Actions */}
                <div className='prof-popup-menu'>
                    <Link to={ROUTES.PROFILE} className='prof-popup-menu-item'>
                        <i className="bi bi-person-circle"></i>
                        My Profile
                    </Link>
                    <Link to={ROUTES.BOOKS_SELLING_CART_PAGE} className='prof-popup-menu-item'>
                        <i className="bi bi-cart-fill"></i>
                        My Cart
                    </Link>
                    <button className='prof-popup-menu-item danger' onClick={handleLogout}>
                        <i className="bi bi-power"></i>
                        Sign Out
                    </button>
                </div>
            </Popover.Body>
        </Popover>
    );

    return (
        <>
            {LogoutModal({ logoutModal, handleCloseLogoutModal })}
            <div className='navigation-wrapper'>
                <div className='navigation-main-container'>
                    <div className='navigation-left'>
                        <button className='navigation-sidebar' onClick={handleSidebarShow} aria-label="Open menu">
                            <i className="bi bi-list"></i>
                        </button>
                        <div className='navigation-heading'>
                            {props.activeItem}
                        </div>
                    </div>
                    <div className='navigation-actions'>
                        <IconButton
                            iconName="bi-cart-fill"
                            badgeCount={0}
                            onChange={() => navigate(ROUTES.BOOKS_SELLING_CART_PAGE)}
                            customStyle={{ fontSize: "19px", height: "40px", width: "40px", color: "#293659" }}
                        />
                        <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={profilePopover}>
                            <div className='navigation-profile-div'>
                                <div className='navigation-profile-img-div'>
                                    <img
                                        src={userData?.profile_image ? userData?.profile_image : PROFILE_IMAGE}
                                        alt="user profile"
                                        className='navigation-profile-img'
                                    />
                                </div>
                                <div className='navigation-text-div'>
                                    <p className='navigation-profile-text'>{userData?.first_name} {userData?.last_name}</p>
                                    <p className='navigation-profile-text-email'>{userData?.email}</p>
                                </div>
                                <i className="bi bi-chevron-down navigation-chevron"></i>
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>

                {/* Tab Navigation — conditionally rendered */}
                {props.tabs && props.tabs.length > 0 && (
                    <div className="tab-navigation-container">
                        <div className="tab-navigation-tabs">
                            {props.tabs.map((tab) => (
                                <div
                                    key={tab.id}
                                    className={`tab-navigation-tab ${props.activeTab === tab.id ? 'active' : ''}`}
                                    onClick={() => props.onTabChange && props.onTabChange(tab.id)}
                                >
                                    {tab.iconClass && <i className={`${tab.iconClass} tab-icon`}></i>}
                                    <span>{tab.label}</span>
                                    {tab.badge && <span className="tab-badge">{tab.badge}</span>}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            <Offcanvas show={sidebarHide} onHide={handleSidebarClose} className="mobile-offcanvas-sidebar">
                <Offcanvas.Header closeButton closeVariant="white" className="mobile-offcanvas-header">
                    <Offcanvas.Title>
                        <img
                            src={MAIN_LOGO_WHITE}
                            width="130px"
                            className="d-inline-block align-top"
                            alt="FRS logo"
                        />
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="mobile-offcanvas-body">
                    <Menu menuItemStyles={menuItemStyles}>
                        {tabsInfo.map((section, idx) => (
                            <React.Fragment key={idx}>
                                {section.canView !== false && (
                                    <>
                                        <div className={`mobile-sb-section-label${idx > 0 ? " mobile-sb-section-label--spaced" : ""}`}>
                                            <span>{section.label}</span>
                                        </div>
                                        {section.items.filter(item => item.canView !== false).map((item, itemIdx) => (
                                            <MenuItem
                                                key={itemIdx}
                                                component={<Link to={item.route} onClick={handleSidebarClose} />}
                                                icon={<i className={`bi ${item.icon}`}></i>}
                                                style={props.activeItem === item.label ? mobileActiveStyle : {}}
                                            >
                                                {item.label}
                                            </MenuItem>
                                        ))}
                                    </>
                                )}
                            </React.Fragment>
                        ))}
                    </Menu>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default TopNavigation;
